"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserControllerApi = exports.UserControllerApiFactory = exports.UserControllerApiFp = exports.UserControllerApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * UserControllerApi - axios parameter creator
 * @export
 */
const UserControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAccountIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersAccountIdDelete', 'id', id);
            const localVarPath = `/api/users/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {boolean} [withInstruments]
         * @param {string} [eventsIds]
         * @param {boolean} [withEventUser]
         * @param {string} [attendanceStatuses]
         * @param {Role} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet: (searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withInstruments, eventsIds, withEventUser, attendanceStatuses, role, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }
            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (withInstruments !== undefined) {
                localVarQueryParameter['withInstruments'] = withInstruments;
            }
            if (eventsIds !== undefined) {
                localVarQueryParameter['eventsIds'] = eventsIds;
            }
            if (withEventUser !== undefined) {
                localVarQueryParameter['withEventUser'] = withEventUser;
            }
            if (attendanceStatuses !== undefined) {
                localVarQueryParameter['attendanceStatuses'] = attendanceStatuses;
            }
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdDelete', 'id', id);
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdGet', 'id', id);
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UserInstrumentPatch} userInstrumentPatch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdInstrumentsPatch: (id, userInstrumentPatch, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdInstrumentsPatch', 'id', id);
            // verify required parameter 'userInstrumentPatch' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdInstrumentsPatch', 'userInstrumentPatch', userInstrumentPatch);
            const localVarPath = `/api/users/{id}/instruments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userInstrumentPatch, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UserInstrumentPut} userInstrumentPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdInstrumentsPut: (id, userInstrumentPut, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdInstrumentsPut', 'id', id);
            // verify required parameter 'userInstrumentPut' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdInstrumentsPut', 'userInstrumentPut', userInstrumentPut);
            const localVarPath = `/api/users/{id}/instruments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userInstrumentPut, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UserNotificationTokenPut} userNotificationTokenPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdNotificationTokensPut: (id, userNotificationTokenPut, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdNotificationTokensPut', 'id', id);
            // verify required parameter 'userNotificationTokenPut' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdNotificationTokensPut', 'userNotificationTokenPut', userNotificationTokenPut);
            const localVarPath = `/api/users/{id}/notificationTokens`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userNotificationTokenPut, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UserPatch} userPatch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPatch: (id, userPatch, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdPatch', 'id', id);
            // verify required parameter 'userPatch' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdPatch', 'userPatch', userPatch);
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userPatch, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdProfileGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdProfileGet', 'id', id);
            const localVarPath = `/api/users/{id}/profile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut: (id, user, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdPut', 'id', id);
            // verify required parameter 'user' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersIdPut', 'user', user);
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(user, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPost: (user, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'user' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersPost', 'user', user);
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(user, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} token
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersTokenPost: (token, user, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersTokenPost', 'token', token);
            // verify required parameter 'user' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersTokenPost', 'user', user);
            const localVarPath = `/api/users/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(user, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userQrCode
         * @param {UserEquipmentPatch} userEquipmentPatch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUserQrCodeEquipmentPatch: (userQrCode, userEquipmentPatch, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userQrCode' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersUserQrCodeEquipmentPatch', 'userQrCode', userQrCode);
            // verify required parameter 'userEquipmentPatch' is not null or undefined
            (0, common_1.assertParamExists)('apiUsersUserQrCodeEquipmentPatch', 'userEquipmentPatch', userEquipmentPatch);
            const localVarPath = `/api/users/{userQrCode}/equipment`
                .replace(`{${"userQrCode"}}`, encodeURIComponent(String(userQrCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userEquipmentPatch, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UserControllerApiAxiosParamCreator = UserControllerApiAxiosParamCreator;
/**
 * UserControllerApi - functional programming interface
 * @export
 */
const UserControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UserControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAccountIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersAccountIdDelete(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {boolean} [withInstruments]
         * @param {string} [eventsIds]
         * @param {boolean} [withEventUser]
         * @param {string} [attendanceStatuses]
         * @param {Role} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withInstruments, eventsIds, withEventUser, attendanceStatuses, role, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withInstruments, eventsIds, withEventUser, attendanceStatuses, role, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersIdDelete(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersIdGet(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UserInstrumentPatch} userInstrumentPatch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdInstrumentsPatch(id, userInstrumentPatch, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersIdInstrumentsPatch(id, userInstrumentPatch, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UserInstrumentPut} userInstrumentPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdInstrumentsPut(id, userInstrumentPut, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersIdInstrumentsPut(id, userInstrumentPut, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UserNotificationTokenPut} userNotificationTokenPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdNotificationTokensPut(id, userNotificationTokenPut, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersIdNotificationTokensPut(id, userNotificationTokenPut, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UserPatch} userPatch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPatch(id, userPatch, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersIdPatch(id, userPatch, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdProfileGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersIdProfileGet(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut(id, user, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersIdPut(id, user, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPost(user, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersPost(user, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} token
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersTokenPost(token, user, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersTokenPost(token, user, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} userQrCode
         * @param {UserEquipmentPatch} userEquipmentPatch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUserQrCodeEquipmentPatch(userQrCode, userEquipmentPatch, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiUsersUserQrCodeEquipmentPatch(userQrCode, userEquipmentPatch, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.UserControllerApiFp = UserControllerApiFp;
/**
 * UserControllerApi - factory interface
 * @export
 */
const UserControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UserControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAccountIdDelete(id, options) {
            return localVarFp.apiUsersAccountIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {boolean} [withInstruments]
         * @param {string} [eventsIds]
         * @param {boolean} [withEventUser]
         * @param {string} [attendanceStatuses]
         * @param {Role} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withInstruments, eventsIds, withEventUser, attendanceStatuses, role, options) {
            return localVarFp.apiUsersGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withInstruments, eventsIds, withEventUser, attendanceStatuses, role, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete(id, options) {
            return localVarFp.apiUsersIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet(id, options) {
            return localVarFp.apiUsersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UserInstrumentPatch} userInstrumentPatch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdInstrumentsPatch(id, userInstrumentPatch, options) {
            return localVarFp.apiUsersIdInstrumentsPatch(id, userInstrumentPatch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UserInstrumentPut} userInstrumentPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdInstrumentsPut(id, userInstrumentPut, options) {
            return localVarFp.apiUsersIdInstrumentsPut(id, userInstrumentPut, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UserNotificationTokenPut} userNotificationTokenPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdNotificationTokensPut(id, userNotificationTokenPut, options) {
            return localVarFp.apiUsersIdNotificationTokensPut(id, userNotificationTokenPut, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {UserPatch} userPatch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPatch(id, userPatch, options) {
            return localVarFp.apiUsersIdPatch(id, userPatch, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdProfileGet(id, options) {
            return localVarFp.apiUsersIdProfileGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut(id, user, options) {
            return localVarFp.apiUsersIdPut(id, user, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPost(user, options) {
            return localVarFp.apiUsersPost(user, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} token
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersTokenPost(token, user, options) {
            return localVarFp.apiUsersTokenPost(token, user, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userQrCode
         * @param {UserEquipmentPatch} userEquipmentPatch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUserQrCodeEquipmentPatch(userQrCode, userEquipmentPatch, options) {
            return localVarFp.apiUsersUserQrCodeEquipmentPatch(userQrCode, userEquipmentPatch, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserControllerApiFactory = UserControllerApiFactory;
/**
 * UserControllerApi - object-oriented interface
 * @export
 * @class UserControllerApi
 * @extends {BaseAPI}
 */
class UserControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersAccountIdDelete(id, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersAccountIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [searchField]
     * @param {string} [searchString]
     * @param {number} [pageSize]
     * @param {number} [pageNumber]
     * @param {string} [sortBy]
     * @param {string} [sortOrder]
     * @param {boolean} [withInstruments]
     * @param {string} [eventsIds]
     * @param {boolean} [withEventUser]
     * @param {string} [attendanceStatuses]
     * @param {Role} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withInstruments, eventsIds, withEventUser, attendanceStatuses, role, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersGet(searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withInstruments, eventsIds, withEventUser, attendanceStatuses, role, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersIdDelete(id, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersIdGet(id, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UserInstrumentPatch} userInstrumentPatch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersIdInstrumentsPatch(id, userInstrumentPatch, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersIdInstrumentsPatch(id, userInstrumentPatch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UserInstrumentPut} userInstrumentPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersIdInstrumentsPut(id, userInstrumentPut, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersIdInstrumentsPut(id, userInstrumentPut, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UserNotificationTokenPut} userNotificationTokenPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersIdNotificationTokensPut(id, userNotificationTokenPut, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersIdNotificationTokensPut(id, userNotificationTokenPut, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {UserPatch} userPatch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersIdPatch(id, userPatch, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersIdPatch(id, userPatch, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersIdProfileGet(id, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersIdProfileGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersIdPut(id, user, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersIdPut(id, user, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersPost(user, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersPost(user, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} token
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersTokenPost(token, user, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersTokenPost(token, user, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} userQrCode
     * @param {UserEquipmentPatch} userEquipmentPatch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApi
     */
    apiUsersUserQrCodeEquipmentPatch(userQrCode, userEquipmentPatch, options) {
        return (0, exports.UserControllerApiFp)(this.configuration).apiUsersUserQrCodeEquipmentPatch(userQrCode, userEquipmentPatch, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserControllerApi = UserControllerApi;
